import { takeEvery, put } from 'redux-saga/effects'

// @ts-ignore
import { parseQuery } from 'helpers/urlHelper'

import { triggerReviewsSurveySubmit, doneReviewsSurveyByIdForReviewer, doneReviewsSurveyByIdForUser } from '../actions'

export function* handleRunReviewsSurveySubmitSaga({ payload }: { type: string; payload: any }) {
  if (payload.reviewerEmail) {
    yield put(doneReviewsSurveyByIdForReviewer(payload))
  } else {
    yield put(doneReviewsSurveyByIdForUser(payload))
  }
}

export default function* runReviewsSurveySubmitSaga() {
  yield takeEvery(triggerReviewsSurveySubmit.toString(), handleRunReviewsSurveySubmitSaga)
}
